import 'common/styles/base.css';

export const CssBaseline = () => null;
